import Moment from 'moment';
import 'moment/locale/fi';

export function parseDate(date){
    return Moment(date).locale('fi').format('LLL');
}